module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"selectOrderTypes":"Select order types","orderTypesSelected":"All order types | {count} order type selected | {count} order types selected"},"no":{"selectOrderTypes":"Velg oppdragstyper","orderTypesSelected":"Alle oppdragstyper | {count} oppdragstype valgt | {count} oppdragstyper valgt"}}')
  delete Component.options._Ctor
}
